"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFlightDelayedFilled = function IconFlightDelayedFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "FlightDelayed"), _react.default.createElement("path", {
    d: "M35 31.79C33.4178 31.79 31.871 32.2592 30.5554 33.1383C29.2399 34.0173 28.2145 35.2667 27.609 36.7285C27.0035 38.1903 26.845 39.7989 27.1537 41.3507C27.4624 42.9026 28.2243 44.328 29.3431 45.4469C30.462 46.5657 31.8874 47.3276 33.4393 47.6363C34.9911 47.945 36.5997 47.7865 38.0615 47.181C39.5233 46.5755 40.7727 45.5502 41.6518 44.2346C42.5308 42.919 43 41.3723 43 39.79C43 37.6683 42.1571 35.6334 40.6569 34.1332C39.1566 32.6329 37.1217 31.79 35 31.79ZM38 40.79H35C34.7348 40.79 34.4804 40.6847 34.2929 40.4971C34.1054 40.3096 34 40.0552 34 39.79V34.79C34 34.5248 34.1054 34.2704 34.2929 34.0829C34.4804 33.8954 34.7348 33.79 35 33.79C35.2652 33.79 35.5196 33.8954 35.7071 34.0829C35.8946 34.2704 36 34.5248 36 34.79V38.79H38C38.2652 38.79 38.5196 38.8954 38.7071 39.0829C38.8946 39.2704 39 39.5248 39 39.79C39 40.0552 38.8946 40.3096 38.7071 40.4971C38.5196 40.6847 38.2652 40.79 38 40.79Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M43.84 8.50001L43.1 10.19C42.3689 11.8684 41.3157 13.387 40 14.66L33.51 21L36.15 29.88C35.7691 29.8248 35.3849 29.7947 35 29.79C33.064 29.7849 31.169 30.3482 29.55 31.41L27.14 27.16L17.4 36.63L18.32 41.3C18.3687 41.6981 18.2612 42.0995 18.02 42.42L16.35 44.54C16.2852 44.6166 16.2023 44.6757 16.1087 44.712C16.0152 44.7482 15.9141 44.7604 15.8146 44.7475C15.7151 44.7346 15.6205 44.6969 15.5393 44.6379C15.4582 44.579 15.3931 44.5006 15.35 44.41L12.66 38.06C12.4859 37.6504 12.1597 37.3242 11.75 37.15L5.40003 34.45C5.30873 34.408 5.22946 34.3436 5.1695 34.2629C5.10954 34.1823 5.07082 34.0878 5.05688 33.9883C5.04294 33.8887 5.05424 33.7872 5.08974 33.6932C5.12523 33.5991 5.18379 33.5155 5.26003 33.45L7.39003 31.78C7.54451 31.6564 7.72281 31.566 7.91378 31.5144C8.10476 31.4628 8.30432 31.4511 8.50003 31.48L13.18 32.39L22.64 22.65L8.25003 14.48C8.14367 14.4241 8.05108 14.3453 7.97897 14.2491C7.90686 14.153 7.85703 14.0421 7.8331 13.9243C7.80917 13.8066 7.81173 13.685 7.8406 13.5684C7.86947 13.4517 7.92393 13.343 8.00003 13.25L9.81003 11.13C9.91403 11.0131 10.0493 10.9283 10.2 10.8858C10.3506 10.8433 10.5102 10.8447 10.66 10.89L28.76 16.27L35.06 9.78001C36.3409 8.45754 37.8701 7.4007 39.56 6.67001L41.24 6.00001C41.5519 5.86214 41.8939 5.8063 42.2334 5.83781C42.573 5.86931 42.8988 5.98711 43.18 6.18001C43.5275 6.4422 43.78 6.81061 43.8991 7.22932C44.0182 7.64803 43.9975 8.09417 43.84 8.50001Z",
    fill: color
  }));
};

IconFlightDelayedFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconFlightDelayedFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconFlightDelayedFilled;
exports.default = _default;